import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {DataService} from '../../../../../Services/data.service';
import {NotificationService} from '../../../../../Services/notification.service';
import {StorageService} from '../../../../../Services/storage.service';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {DateFilterService} from '../../../../../Services/dateFilter.service';
import {DataExportService} from '../../../../../Services/dataExport.service';
import {ResponseModel} from '../../../../../DataModels/response-model';
import {EmailModel} from '../../../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {SendEmailModalComponent} from '../../../../common/send-email-modal/send-email-modal.component';
import {ReportPrintService} from '../../../../../Services/report-print.service';

@Component({
  selector: 'app-count-report',
  templateUrl: './count-report.component.html',
  styleUrls: ['./count-report.component.css'],
  standalone: false
})

export class CountReportComponent implements OnInit, AfterViewInit {

  @ViewChild('ExcelExport', {static: false}) ExcelExport: ElementRef;

  // Email modal integration
  reportDataToSendInEmail: EmailModel = new EmailModel();
  @ViewChild(SendEmailModalComponent, {read: ElementRef}) private localSendEmailModalHost: ElementRef;

  constructor(
    private router: Router,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: NotificationService,
    private dateFilter: DateFilterService,
    private excelExporter: DataExportService,
    private datePipe: DatePipe,
    private titleService: Title,
    private reportPrint: ReportPrintService
  ) {
    this.vm.title = $localize`:Inventory Count Report @@inventoryCountReport:Inventory Count Report`;
    this.vm.item = {};
    this.vm.tempitems = {};
    this.vm.countSearch = null;
    this.vm.showAdjustmensOnly = false;
    this.vm.systemCount = [];
    this.vm.systemCount.locations = [];
    this.vm.systemCount.locations.items = [];
    this.vm.exportToExcel = true;
  }

  // removed unused itemBalances
  // itemBalances = [];
  vm: any = {
    report: [],
    reportHeaders: [],
    request: {
      fromDate: null,
      toDate: null,
      company_id: null,
      location_id: null,
      count_id: null,
      category: null,
      locked: null as boolean | null
    },
    exportToExcel: true,
    item: {},
    showFilters: false,
    showSpecificDates: false,
    // Report now always uses the new data shape (array of headers)
    // Controls whether rows with zero system and zero physical counts are shown
    showZeroItems: false,
    toDateSelect: [],
    fromDateSelect: [],
    monthCount: 0,
    filtered: false,
    fromDateError: false,
    toDateError: false
  };
  isLoaded = false;
  counts: [];
  buttonConfig = {
    print: false,
    printReport: true,
    email: true,
    exportExcel: true,
    close: true,
    update: true
  };



  ngOnInit() {

    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions', ''));
    if (!this.vm.permissions.EditCounts && !this.vm.permissions.ViewCounts && !this.vm.permissions.Admin) {
      document.location.href = '/';
    }

    // initialize date select options
    this.newDateFilter(new Date(), new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    if (!this.vm.request.fromDate) {
      this.vm.request.fromDate = this.vm.fromDateSelect?.[0]?.date || this.dateFilter.GetDateFormat(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    }
    if (!this.vm.request.toDate) {
      this.vm.request.toDate = this.vm.toDateSelect?.[0]?.date || this.dateFilter.GetDateFormat(new Date());
    }

    this.loadLookupOptions();
    // this.loadData();
    // this.loadCount();
    // this.init();
    this.vm.buttonsDisabled = false;
    this.isLoaded = true;
    this.vm.report = this.vm.item;
  }

  // Removed isZeroItem(): Zero Items toggle has been removed from UI per requirements.

  ngAfterViewInit() {
    this.titleService.setTitle(this.vm.title);
  }

  loadLookupOptions() {
    this.vm.inventoryItem = [];
    this.tableDataService.getApiListData('item', '?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.inventoryItem = result.Data;
    });

    this.vm.company = [];
    this.tableDataService.getApiListData('company', '?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.company = result.Data;
    });

    this.vm.currency = [];
    this.tableDataService.getApiListData('currency', '?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.currency = result;
    });

    this.vm.location = [];
    this.tableDataService.getApiListData('location', '?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.location = result.Data;
    });

    this.vm.category = [];
    this.tableDataService.getApiListData('item_category', '?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.category = result.Data;
    });
  }

  loadCount() {
    // Build query params per requirement: fromDate, toDate, companyId, locationId, countId, category, locked
    const q = this.encodeQueryData({
      fromDate: this.dateFilter.GetDateFormat(this.vm.request.fromDate),
      toDate: this.dateFilter.GetDateFormat(this.vm.request.toDate),
      companyId: this.vm.request.company_id,
      locationId: this.vm.request.location_id,
      countId: this.vm.request.count_id,
      category: this.vm.request.category,
      locked: this.vm.request.locked
    });

    this.tableDataService.getApiListData('CountReport/detail', '?' + q).subscribe((result: any) => {
      // API returns new data shape only: an array of headers in result or result.Data
      const headers = Array.isArray(result?.Data) ? result.Data : (Array.isArray(result) ? result : []);
      this.vm.reportHeaders = headers || [];

      // Build simple search_string on each line for filter pipe compatibility (new data shape)
      for (const h of this.vm.reportHeaders) {
        if (Array.isArray(h?.count)) {
          for (const i of h.count) {
            const parts = [i.code, i.name, i.category_name, i.uom_name]
              .map(v => (v == null ? '' : String(v)))
              .filter(v => v && v.trim().length > 0);
            i.search_string = parts.join(' ').trim();
          }
        }
      }
      // Activate header buttons by setting a non-empty report reference
      this.vm.report = this.vm.reportHeaders;
      // console.log('count headers:', this.vm.reportHeaders);
      //this.init();
    });
    this.vm.buttonsDisabled = false;
  }

  // UI helpers for header summary labels
  getCompanyLabel(): string {
    const id = this.vm.request?.company_id;
    if (!id) {
      return 'All Companies';
    }
    const c = (this.vm.company || []).find(x => x.id === id);
    return c?.name || 'All Companies';
  }

  getLocationLabel(): string {
    const id = this.vm.request?.location_id;
    if (!id) {
      return 'All Locations';
    }
    const l = (this.vm.location || []).find(x => x.id === id);
    return l?.name || 'All Locations';
  }

  getCategoryLabel(): string {
    const id = this.vm.request?.category;
    if (!id) {
      return 'All Categories';
    }
    const cat = (this.vm.category || []).find(x => x.id === id);
    return cat?.name || 'All Categories';
  }

  getLockedFilterLabel(): string {
    const val = this.vm.request?.locked;
    if (val === true) {
      return 'Locked';
    }
    if (val === false) {
      return 'Unlocked';
    }
    return 'All';
  }

  // Item history for a specific header context (new shape)
  getItemHistoryForHeader(header: any, item_id: any) {
    if (!header) {
      return;
    }
    this.vm.itemHistoryId = item_id;
    this.vm.itemHistory = [];

    const urlParamsJson = {
      count_date: this.datePipe.transform(header.count_date, 'MM/dd/yyyy'),
      company_id: header.company_id,
      location_id: header.location_id,
      item_id,
      pageNumber: 0,
      pageSize: 999999
    };
    const CountParam: string = this.encodeQueryData(urlParamsJson);
    this.tableDataService.getApiListData('Count/system/history?' + CountParam).subscribe((result: ResponseModel) => {
      this.vm.itemHistory = result.Data;
      // console.log('item history (new shape):', this.vm.itemHistory);
    });
  }

  // Initialize/refresh the date selector preset lists
  newDateFilter(toDate: any, fromDate: any) {
    const df = this.dateFilter.DateFilterInit(toDate, fromDate);
    this.vm.monthCount = df.monthCount;
    this.vm.fromDateSelect = df.fromDateSelect;
    this.vm.toDateSelect = df.toDateSelect;
  }

  // Called when user clicks Update in header
  onUpdate() {
    this.updateFilteredFlag();
    // this.loadLookupOptions();

    this.loadCount();
    // }
  }

  onFilterChanged() {
    this.updateFilteredFlag();
  }

  private updateFilteredFlag() {
    const hasFilters = !!(
      this.vm.request?.company_id ||
      this.vm.request?.location_id ||
      this.vm.request?.category ||
      this.vm.request?.locked
    );
    this.vm.filtered = !!hasFilters;
  }

  exportToExcel() {
    this.excelExporter.exportToExcel(this.ExcelExport, 'Inventory-Count-Report.xlsx');
  }

  setEmailData() {
    const reportName = 'Inventory Count Report';
    const emailDocObj = {} as EmailModel;
    emailDocObj.print_orientation = '1';
    emailDocObj.convert_attachment_to = 'pdf';
    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '';
    emailDocObj.toEmail = '';
    emailDocObj.body = 'Please see the attached ' + reportName + '.<br><br><br>' + 'Best regards,' + '<br><br>' + 'AcctXErp' + '<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + reportName;

    // Unified HTML for both Email and Print
    try {
      emailDocObj.pdfHtml = this.buildPrintHtml(true);
    } catch {
      // Fallback to raw export HTML
      emailDocObj.pdfHtml = this.ExcelExport?.nativeElement?.outerHTML || document.getElementById('excel-export')?.outerHTML || '';
    }
    emailDocObj.activity_message = reportName;

    const now = new Date();
    const yyyy = String(now.getFullYear());
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    emailDocObj.FileName = 'Inventory_Count_Report_' + yyyy + mm + dd + '.pdf';

    this.reportDataToSendInEmail = emailDocObj;

    const element = document.getElementById('sendEmailModal') as HTMLElement;
    if (element) {
      const emailModal = new Modal(element);
      emailModal.show();
    }
  }

  // Print via hidden iframe using the same HTML builder
  printReport() {
    try {
      const html = this.buildPrintHtml(false);
      this.printHtmlInIframe(html);
    } catch (err) {
      // as a last resort
      window.print();
    }
  }

  // Build a self-contained HTML for print/email using the hidden export content
  private buildPrintHtml(forEmail: boolean = false): string {
    const rawContent = (this.ExcelExport?.nativeElement?.outerHTML || document.getElementById('excel-export')?.outerHTML || '').toString();
    const content = this.reportPrint.cleanContentHtml(rawContent);
    const from = '';
    const to = this.vm?.item?.count_date || '';
    const meta: { label: string; value: string }[] = [];
    if (from || to) {
      meta.push({label: 'Period', value: from && to ? `${from} to ${to}` : (from || to)});
    }
    return this.reportPrint.buildHtml({title: 'Inventory Count Report', contentHtml: content, meta, orientation: 'landscape'});
  }

  private printHtmlInIframe(html: string): void {
    this.reportPrint.printInIframe(html);
  }

  private escapeHtml(input: any): string {
    if (input == null) {
      return '';
    }
    return String(input)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  getItemHistory(item_id) {
    this.vm.itemHistoryId = item_id;
    this.vm.itemHistory = [];

    const urlParamsJson = {
      count_date: this.datePipe.transform(this.vm.item.count_date, 'MM/dd/yyyy'),
      company_id: this.vm.item.company_id,
      location_id: this.vm.item.location_id,
      item_id,
      pageNumber: 0,
      pageSize: 999999
    };

    const CountParam: string = this.encodeQueryData(urlParamsJson);
    this.tableDataService.getApiListData('Count/system/history?' + CountParam).subscribe((result: ResponseModel) => {
      this.vm.itemHistory = result.Data;
      // console.log('item history:', this.vm.itemHistory);
    });
  }

  encodeQueryData(data) {
    const ret = [];
    for (const d in data) {
      if (data[d] != null && data[d] != '') {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
    }
    return ret.join('&');
  }


  close() {
    this.router.navigateByUrl('/home').then();
  }


  clearFilters() {
    // Reset filters and date presets to defaults
    this.vm.request.company_id = null;
    this.vm.request.location_id = null;
    this.vm.request.count_id = null;
    // keep the current date range but repopulate selects
    this.newDateFilter(this.vm.request.toDate || new Date(), this.vm.request.fromDate || new Date());
    this.vm.filtered = false;
    this.loadLookupOptions();
    this.notification.info('Filters cleared');
  }
}
